import { api } from "@/auth/AuthContext";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const formatCount = (value) => Number(value || 0).toLocaleString("id-ID");

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
  URL.revokeObjectURL(url);
};

export const exportProgressText = (job) => {
  if (!job) return "Menyiapkan…";
  if (job.status === "completed") return "Mengunduh file…";
  const total = Number(job.total_rows || 0);
  const processed = Number(job.processed_rows || 0);
  const percent = total ? Math.min(99, Math.round((processed / total) * 100)) : 0;
  return `${job.phase || "Memproses"} · ${formatCount(processed)} / ${formatCount(total)} (${percent}%)`;
};

export const runStudentExport = async ({ startPath, params, onProgress }) => {
  const started = await api.post(startPath, null, { params });
  let job = started.data;
  onProgress?.(job);
  for (let attempt = 0; attempt < 3600 && !["completed", "failed"].includes(job.status); attempt += 1) {
    await wait(attempt < 10 ? 700 : 1500);
    job = (await api.get(`/students/export/jobs/${job.job_id}`)).data;
    onProgress?.(job);
  }
  if (job.status === "failed") throw new Error(job.error || "Gagal menyiapkan file ekspor.");
  if (job.status !== "completed") throw new Error("Proses ekspor belum selesai. Silakan coba kembali beberapa saat lagi.");
  const file = await api.get(`/students/export/jobs/${job.job_id}/file`, { responseType: "blob" });
  downloadBlob(file.data, job.filename);
  return job;
};
